export const KIKU_COURSE_SEARCH_URL =
    'https://www.aws.training/LearningLibrary';
export const SKILLBUILDER_URL = 'https://explore.skillbuilder.aws/learn';
export const CERTIFICATION_URL = 'https://aws.training/Certification';
